import { CurrentOpenMenu } from '@/pages/Search/SearchPage/types';
import { QuickFilterName } from '@/utils/amplitude/analytics/searchPage';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { FacetOptionsPill } from '../FacetOptionsPill/FacetOptionsPill';

type Props = {
    currentOpenMenu?: CurrentOpenMenu;
    onMenuClose: () => void;
    onMenuOpen: (currentMenu: CurrentOpenMenu) => void;
};

// `subject` is the live facet id from ssa-api's dynamic Attrs.Subject facet.
// FacetTypes.ART_SUBJECT_ID ('artSubject') is a separate legacy enum used by
// SEO browse-URL routing only — different value, do not substitute here.
export const SUBJECT_FACET_ID = 'subject';

export const SubjectPill = ({ currentOpenMenu, onMenuClose, onMenuOpen }: Props) => {
    const formatMessage = useAppFormatMessage();
    return (
        <FacetOptionsPill
            currentOpenMenu={currentOpenMenu}
            facetId={SUBJECT_FACET_ID}
            /* As long as the translation key doesn't change, we can guarantee that this will be a string */
            label={String(formatMessage(['search_facet_title_subject']))}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            openMenuId={CurrentOpenMenu.Subject}
            quickFilterName={QuickFilterName.Subject}
        />
    );
};
